import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Dialog, FontIcon } from 'react-toolbox';
import UserNote from 'components/UserNote';
import ReactTooltip from 'react-tooltip';
import { ThemeProvider } from 'react-css-themr';
import S from './itemNote.scss';
import inputStyles from 'styles/input';
import { error as parseError } from '../../../utils';
import InputNote from 'components/LineItemTable/inputNote';
import MediaQuery from 'react-responsive';
import { CUT_POINT } from 'config/constants';

const errStyles = `${inputStyles.error} ${S.error}`;
const errWrapperStyles = `${inputStyles.errored} ${S.errored}`;


class ItemNote extends Component {
  state = { active: false };

  toggleActive = () => {
    const active = !this.state.active;
    this.setState({ active });
  }

  handleChange = e => this.context.onChange(e, this.props.onChange)

  renderItemNoteDesktop = () => {
    const { isEditable } = this.context;
    const { active } = this.state;
    const { id, kind, note, errors, readOnly } = this.props;
    const emptyNoteClass = note ? '' : S.no_content;
    const error = errors.note && parseError('note', errors);
    return (
      <td className={S.container}>
        {(isEditable || note) &&
          <FontIcon value="note" data-tip data-for={`${kind}${id}`} className={`${S.note_icon} ${emptyNoteClass}`} onClick={this.toggleActive} />
        }
        {error && <div className={errWrapperStyles}>
          <p className={errStyles}>{error}</p>
        </div>}
        {note && <ReactTooltip id={`${kind}${id}`} place="left" effect="solid">
          <UserNote className={S.tooltipText}>{note}</UserNote>
        </ReactTooltip>}
        {active && <ThemeProvider>
          <Dialog title="Note" active={active} onEscKeyDown={this.toggleActive} onOverlayClick={this.toggleActive}>
            <FontIcon value="close" className={S.close_icon} onClick={this.toggleActive} />
            {(isEditable && !readOnly) &&
              <textarea className={S.textarea} value={note} onChange={this.handleChange} />
            }
            {(!isEditable || readOnly) && <UserNote className={S.text}>{note}</UserNote>}
          </Dialog>
        </ThemeProvider>}
      </td>
    );
  }

  renderItemNoteMobile = () => {
    const { note, errors } = this.props;
    const error = errors.note && parseError('note', errors);
    return (
      <React.Fragment>
        <InputNote type="text" attr="note" label="Note" value={note} onChange={this.handleChange} />
        {error && <div className={errWrapperStyles}>
          <p className={errStyles}>{error}</p>
        </div>}
      </React.Fragment>
    );
  }

  render() {
    return (
      <MediaQuery minWidth={CUT_POINT}>
        {(matches) => {
          if (matches) {
            return this.renderItemNoteDesktop();
          }
          return this.renderItemNoteMobile();
        }}
      </MediaQuery>
    );
  }
}

ItemNote.contextTypes = {
  onChange: PropTypes.func,
  isEditable: PropTypes.bool,
};

ItemNote.defaultProps = {
  note: '',
  errors: {},
  kind: 'note',
  readOnly: false,
};

ItemNote.propTypes = {
  display: PropTypes.bool.isRequired,
  note: PropTypes.string,
  errors: PropTypes.object,
  label: PropTypes.string.isRequired,
  kind: PropTypes.string.isRequired,
  id: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

export default ItemNote;



// WEBPACK FOOTER //
// ./client/app/shared/components/LineItemTable/itemNote.jsx